import { createContext, useContext, useReducer } from 'react';
import { DashboardState, DashboardReducer, ACTION_TYPES } from './dashboard-reducer';

const DashboardContext = createContext<DashboardState | undefined>(undefined);
const DashboardDispatchContext = createContext({} as any);

const DashboardProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: DashboardState = {
        dashboardData: null,
        loading: false,
        error: null,
    };

    const [state, dispatch] = useReducer(DashboardReducer, initialState);

    return (
        <DashboardContext.Provider value={state}>
            <DashboardDispatchContext.Provider value={dispatch}>
                {children}
            </DashboardDispatchContext.Provider>
        </DashboardContext.Provider>
    );
};

const useDashboardState = () => {
    const context = useContext(DashboardContext);
    if (context === undefined) {
        throw new Error('useDashboardState must be used within a DashboardProvider');
    }
    return context;
};

const useDashboardDispatch = () => {
    const context = useContext(DashboardDispatchContext);
    if (context === undefined) {
        throw new Error('useDashboardDispatch must be used within a DashboardProvider');
    }
    return context;
};

export { DashboardProvider, useDashboardDispatch, useDashboardState, ACTION_TYPES };
